/**
 * Data to change user password.
 */
export interface ChangePasswordContract {
  old_password: string;
  new_password1: string;
  new_password2: string;
}
